module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-30-min.a23877ee.jpg";